import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import MainPage from './components/MainPage';
import Recintos from './components/Recintos';
import Proveedores from './components/Proveedores';
import Escaneos from './components/Escaneos';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  const handleLoginSuccess = () => 
  {
    setIsAuthenticated(true);
  };

  const handleLogout = () => 
  {
    setIsAuthenticated(false);
  };

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          
          <Route
            path="/main"
            element={<PrivateRoute element={<MainPage onLogout={handleLogout} />} isAuthenticated={isAuthenticated} />}
          >
            <Route path="recintos" element={<Recintos />} />
            <Route path="proveedores" element={<Proveedores />} />
            <Route path="escaneos" element={<Escaneos />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
